import { render, staticRenderFns } from "./add-edit-user.vue?vue&type=template&id=25bfe285&scoped=true"
import script from "./add-edit-user.vue?vue&type=script&lang=js"
export * from "./add-edit-user.vue?vue&type=script&lang=js"
import style0 from "./add-edit-user.vue?vue&type=style&index=0&id=25bfe285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfe285",
  null
  
)

export default component.exports